import type { PersonalLoan } from '@/api/personalLoans'
import { isOverdue } from '@/lib/personalLoans'

export function LoanStatusBadges({ loan }: { loan: PersonalLoan }) {
  return (
    <>
      {isOverdue(loan) && (
        <span className="rounded-full bg-[var(--fl-warning-bg)] px-2 py-0.5 text-xs font-medium text-[var(--fl-warning)]">
          Overdue
        </span>
      )}
      {loan.closed && (
        <span className="rounded-full bg-[var(--fl-surface-subtle)] px-2 py-0.5 text-xs font-medium text-[var(--fl-text-2)]">
          Closed
        </span>
      )}
    </>
  )
}
